import { useAuth } from "@/hooks/use-auth";
import { canDo } from "@shared/roles";

export interface ClientPermissions {
  canSendBienvenue: boolean;
  canValidate: boolean;
  canManage: boolean;
  canSend: boolean;
}

export function useClientPermissions(): ClientPermissions {
  const { profile } = useAuth();
  return {
    canSendBienvenue: canDo(profile?.accessRole) || profile?.role === "commercial",
    canValidate: canDo(profile?.accessRole) || profile?.role === "planification",
    canManage: canDo(profile?.accessRole),
    canSend: canDo(profile?.accessRole) || profile?.role === "commercial",
  };
}
